import { useQuery } from 'react-query';

import { GetDocChronologyBundleItemsResponseDto } from '../../../../backend/src/matter/subset/chronology/doc-chronology/dto/get-doc-chron-bundle-items-response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetDocChronologyBundleItems = ({
  matterId,
  subsetId,
  docChronologyId,
  enabled = true,
}: {
  matterId: string;
  subsetId: string;
  docChronologyId: string;
  enabled?: boolean;
}) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<GetDocChronologyBundleItemsResponseDto>(
    [QueryEntity.DocChronologyBundleItems, { docChronologyId }],
    async () => {
      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/doc-chronology/${docChronologyId}/bundle-items`,
        fetchConfigGET,
      );
      if (!res.ok) {
        throw new Error(`Failed to load bundle items (${res.status})`);
      }
      return res.json();
    },
    { enabled: enabled && !!matterId && !!subsetId && !!docChronologyId },
  );
};
